

const app = {
    state: {
        numberNo: '',
        nameCar: ''
    },
    mutations: {
        SET_NUMBERNO: (state, numberNo) => {
            state.numberNo = numberNo;
        },
        SET_NAMECAR: (state, nameCar) => {
            state.nameCar = nameCar;
        }
    },
    actions: {
        setNumberNo({commit}, id) {
            commit('SET_NUMBERNO', id);
        },
        setNameCar({commit}, id) {
            commit('SET_NAMECAR', id);
        }
    }
};

export default app;
